export const WidgetType = {
	tag: 'tag',
	component: 'component',
};
